import { IToastModal } from '../interfaces/components/modal.interface';

export const handleToastIncommingModal = ({
  toast,
  cta_1_action,
  cta_2_action,
}: {
  toast: IToastModal;
  cta_1_action?: Function;
  cta_2_action?: Function;
}) => {
  return toast.cta({
    content: 'Tính năng sắp được ra mắt. Bạn có mong muốn sử dụng?',
    cta_1_name: 'Có',
    cta_1_action: cta_1_action,
    cta_2_name: 'Bỏ qua',
    cta_2_action: cta_2_action,
    closedAfterCTA2: true,
    closedAfterCTA1: true,
  });
};
